import React, { useEffect, useState } from "react";
import Select from "react-select";
import useLang from "Shared/hooks/useLanguage";
import SpecimenTypeAssigmentService from "../../../Services/Compendium/SpecimenTypeAssigmentService";
import { reactSelectStyle, styles } from "../../../Utils/Common";
import { PanelNameLookup } from "Services/Compendium/ReportDisclaimer";
import { Collapse } from "@mui/material";
import { LoaderIcon } from "Shared/Icons";

interface SpecimenType {
  value: number;
  label: string;
}

interface PanelNameDetails {
  panelId: number;
  panel: string;
}

interface Requisition {
  value: number;
  label: string;
}

interface RequisitionDetails {
  reqTypeId: number;
  requisitionTypeName: string;
}

function AddReportDisclaimer({
  errors,
  isShow,
  values,
  request,
  loadData,
  setErrors,
  openModal,
  setValues,
  setPanels,
  setRequest,
  setSports2,
  modalheader,
  setOpenModal,
  handleSubmit,
  editGridHeader,
  handleOnChange,
  setEditGridHeader,
  disableSavebutton,
  setSelectedPanels,
}: any) {
  const { t } = useLang();

  const [PanelName, setPanelName] = useState<SpecimenType[]>([]);
  const [RequisitionList, setRequisitionList] = useState<Requisition[]>([]);

  const GetRequisition = () => {
    SpecimenTypeAssigmentService.RequisitionTypeLookup().then((res: any) => {
      let list: Requisition[] = [];
      res?.data?.data.forEach(
        ({ reqTypeId, requisitionTypeName }: RequisitionDetails) => {
          list.push({
            value: reqTypeId,
            label: requisitionTypeName,
          });
        }
      );
      setRequisitionList(list);
    });
  };

  const GetSpecimenType = (reqTypeId: number) => {
    if (!reqTypeId) return;

    PanelNameLookup(reqTypeId).then((res: any) => {
      const list: SpecimenType[] = res?.data?.data?.map((item: any) => ({
        value: item.id,
        label: item.panelName,
      }));

      setPanelName(list);
    });
  };

  const clearPanels = () => {
    setPanels([]);
    setSports2([]);
    setSelectedPanels([]);
  };

  useEffect(() => {
    GetRequisition();
  }, []);

  useEffect(() => {
    if (values.reqTypeId) {
      GetSpecimenType(values.reqTypeId);
    } else {
      setPanelName([]);
    }
  }, [values.reqTypeId]);

  const onRequisitionSelect = (e: any) => {
    clearPanels();

    setValues((pre: any) => ({
      ...pre,
      reqTypeId: e?.value || null,
      reqTypeName: e?.label || "",
      panelId: 0,
      panelName: "",
    }));
  };

  const onPanelSelect = (e: any) => {
    setValues((pre: any) => ({
      ...pre,
      panelId: e ? e.value : 0,
      panelName: e ? e.label : "",
    }));
  };

  return (
    <>
      <Collapse in={openModal}>
        <div className="app-content flex-column-fluid">
          <div className="app-container container-fluid ">
            <div id="ModalCollapse" className="card">
              <div className="align-items-center bg-light-warning card-header d-flex justify-content-center justify-content-sm-between gap-3 minh-42px">
                <h5 className="m-0 ">{modalheader}</h5>
                <div className="d-flex align-items-center gap-2 gap-lg-3">
                  <button
                    className="btn btn-secondary btn-sm fw-bold "
                    aria-controls="SearchCollapse"
                    aria-expanded="true"
                    onClick={() => {
                      setOpenModal(false);
                      setValues((preVal: any) => {
                        return {
                          ...preVal,
                          id: 0,
                          reqTypeId: 0,
                          panelId: 0,
                          isActive: true,
                        };
                      });
                      setErrors((pre: any) => {
                        return {
                          disclaimer: "",
                          requisitionError: "",
                        };
                      });
                      setPanels([]);
                      setValues({
                        reqTypeId: 0,
                        panelId: 0,
                        disclaimer: "",
                        isActive: true,
                      });
                      setEditGridHeader(false);
                      setSelectedPanels([]);
                      setSports2([]);
                      loadData(false);
                      isShow(false);
                      setRequest(false);
                    }}
                  >
                    <span>
                      <i className="fa fa-times"></i>
                      <span>{t("Cancel")}</span>
                    </span>
                  </button>
                  <button
                    className="btn btn-primary btn-sm btn-primary--icon px-7"
                    onClick={handleSubmit}
                    disabled={disableSavebutton}
                  >
                    <span>
                      {request ? <LoaderIcon /> : null}
                      <span>{t(editGridHeader ? "Update" : "Save")}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div id="form-search" className=" card-body py-3">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div className="fv-row mb-4">
                      <label className="required mb-2">
                        {t("Requisition Type")}
                      </label>
                      <Select
                        inputId={`ReportDisclaimerRequisitionType`}
                        menuPortalTarget={document.body}
                        styles={reactSelectStyle}
                        theme={(theme: any) => styles(theme)}
                        options={RequisitionList}
                        name="reqTypeId"
                        placeholder={t("Select Requisition Type")}
                        value={RequisitionList.filter(function (option: any) {
                          return option.value === values.reqTypeId;
                        })}
                        onChange={(e: any) => onRequisitionSelect(e)}
                        isSearchable={true}
                        isClearable={true}
                        className="z-index-3"
                      />
                      <span style={{ color: "red" }}>
                        {errors.requisitionError}
                      </span>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div className="fv-row mb-4">
                      <label className=" mb-2">{t("Panel Name")}</label>
                      <Select
                        inputId={`ReportDisclaimerPanelName`}
                        menuPortalTarget={document.body}
                        styles={reactSelectStyle}
                        theme={(theme: any) => styles(theme)}
                        options={PanelName}
                        name="panelId"
                        placeholder={t("Select Panel Name")}
                        value={PanelName.filter(function (option: any) {
                          return option.value === values.panelId;
                        })}
                        onChange={(e: any) => onPanelSelect(e)}
                        isSearchable={true}
                        isClearable={true}
                        required={true}
                        className="z-index-3"
                      />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 mb-3">
                    <label className="mr-2 mb-2 fw-bold">
                      {t("Inactive/Active")}
                    </label>
                    <div className="form-check form-switch mb-2">
                      <input
                        id={`ReportDisclaimerSwitchButton`}
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        name="isActive"
                        // disabled={editGridHeader}
                        onChange={handleOnChange}
                        checked={values.isActive}
                        defaultChecked={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 pt-3">
                    <label>
                      <h6>{t("Disclaimer")}</h6>
                    </label>
                    <textarea
                      id="ReportDisclaimer"
                      className="form-control h-65px"
                      value={values.disclaimer}
                      onChange={(e) =>
                        setValues((pre: any) => ({
                          ...pre,
                          disclaimer: e.target.value,
                        }))
                      }
                    />
                    <span style={{ color: "red" }}>{errors.disclaimer}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Collapse>
    </>
  );
}

export default AddReportDisclaimer;
